import { render, staticRenderFns } from "./ContentEditor.vue?vue&type=template&id=48af3704&"
import script from "./ContentEditor.vue?vue&type=script&lang=js&"
export * from "./ContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports